import React from 'react';
import { PropTypes } from 'prop-types';

import Button from '../../common/components/Button';
import ConfirmButton from '../../common/components/ConfirmButton';
import ListItem from '../common/ListItem';
import I18N from '../../common/i18n';
import icons from '../../common/icons';
import { Sections, AppSections } from '../../common/enums';

export default
class UserListItem extends React.PureComponent {

  static section = Sections.ZONES;

  static propTypes = {
    item: PropTypes.object.isRequired,
    onDelete: PropTypes.func,
  }

  render() {
    const user = this.props.item;

    return (
      <ListItem
        id={user.id}
        link={`/${AppSections.CATALOG}/${Sections.USERS}/${user.id}`}
        key={user.id}
        title={`${user.name} :: ${user.id}`}
        extra={user.phone}
      >
        <div className='ListItem__Controls'>
          {this.props.onDelete &&
            <ConfirmButton
              confirmMessage={`${I18N.USERS_DELETE_CONFIRM} «${user.name}»`}
              icon={icons.COMMON_DELETE} leftHint={I18N.ITEM_DELETE}
              onClick={() => this.props.onDelete(user.id)}/>
          }
          <Button icon={icons.COMMON_EDIT} leftHint={I18N.ITEM_EDIT}
            to={`/${AppSections.CATALOG}/${Sections.USERS}/${user.id}/edit`} />
        </div>
      </ListItem>
    );
  }
}
